import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import CssBaseline from '@material-ui/core/CssBaseline';
import * as serviceWorker from './serviceWorker';
import { configureStore, history } from './utils/configureStore';
import { Provider } from 'react-redux';
import Amplify from 'aws-amplify';
import { amplifyConfig } from './config/awsConfig';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { ConnectedRouter } from 'connected-react-router';

Amplify.configure(amplifyConfig);

const store = configureStore();

const theme = createMuiTheme({
  palette: {
    primary: { main: '#ce9568' },
    secondary: { main: '#e0a16d' }
  }
});
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline>
          <App />
        </CssBaseline>
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
